import {
  Button,
  Chip,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Link as RouterLink } from 'react-router';
import type { RegistryResource } from '../../../api/src/registry/registry.types';
import { Stack, Typography } from '../components/mui-system';
import { RegistryOwnershipChip } from './RegistryCatalogTable';

const actionLabels = {
  workspace: 'Настроить',
  telegram: 'Открыть канал',
  donor: 'Открыть статью',
  manual: 'Открыть запись',
};
const roleLabels = {
  primary: 'Основной сайт',
  reference: 'Образец',
  donor: 'Донор',
  competitor: 'Конкурент',
};
export function registrySourceLink(
  row: Pick<RegistryResource, 'source' | 'sourceId' | 'address'>,
): string {
  const id = encodeURIComponent(row.sourceId);
  switch (row.source) {
    case 'manual':
      return `/registry?entry=${id}`;
    case 'workspace':
      return '/settings';
    case 'telegram':
      return `/registry?telegram=${id}`;
    case 'donor':
      return `/donors?donor=${id}`;
  }
}
export function RegistryResourceTable({ items }: { items: RegistryResource[] }) {
  return (
    <TableContainer>
      <Table size="small" aria-label="Записи и публикации">
        <TableHead>
          <TableRow>
            <TableCell>Запись / точный URL</TableCell>
            <TableCell>Принадлежность</TableCell>
            <TableCell>Роли</TableCell>
            <TableCell>Источник</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.key}>
              <TableCell sx={{ maxWidth: 480, overflowWrap: 'anywhere' }}>
                <Stack gap={0.5}>
                  {row.title !== row.url && row.title !== row.address && (
                    <Typography variant="body2" fontWeight={600}>
                      {row.title}
                    </Typography>
                  )}
                  {row.url && /^https?:\/\//.test(row.url) ? (
                    <Link href={row.url} target="_blank" rel="noreferrer">
                      {row.url}
                    </Link>
                  ) : (
                    <Typography variant="body2">{row.address}</Typography>
                  )}
                  {row.notes && (
                    <Typography variant="body2" color="text.secondary">
                      {row.notes}
                    </Typography>
                  )}
                </Stack>
              </TableCell>
              <TableCell>
                <RegistryOwnershipChip value={row.ownership} />
                <Typography variant="caption" color="text.secondary" display="block">
                  {row.kind === 'domain' || row.source === 'workspace'
                    ? 'На уровне ресурса'
                    : 'Область исходной записи'}
                </Typography>
              </TableCell>
              <TableCell>
                <Stack gap={0.5} alignItems="flex-start">
                  {row.roles.map((role) => (
                    <Chip key={role} size="small" label={roleLabels[role]} variant="outlined" />
                  ))}
                </Stack>
              </TableCell>
              <TableCell>
                <Button component={RouterLink} to={registrySourceLink(row)} size="small">
                  {actionLabels[row.source]}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
